import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    MenuItem,
    Select,
    Box,
    Typography
} from '@mui/material';

interface StatusOption {
    value: string;
    label: string;
}

interface UpdateStatusProps {
    confirmOpen: boolean;
    setSelectedStatus: (status: string) => void;
    selectedStatus: string;
    handleCancelStatusChange: () => void;
    handleConfirmStatusChange: () => void;
}

export const UpdateStatus: React.FC<UpdateStatusProps> = ({
    confirmOpen,
    setSelectedStatus,
    selectedStatus,
    handleCancelStatusChange,
    handleConfirmStatusChange
}) => {
    const statusOptions: StatusOption[] = [
        { value: "Pending", label: "Pending" },
        { value: "packed", label: "packed" },
        { value: "Shipped", label: "Shipped" },
        { value: "Delivered", label: "Delivered" },
        
    ];

    return (
        <Dialog open={confirmOpen} onClose={handleCancelStatusChange}>
            <DialogTitle>Confirm Status Change</DialogTitle>
            <DialogContent>
                <Box sx={{ mt: 2, mb: 3 }}>
                    <Select
                        value={selectedStatus}
                        onChange={(e) => setSelectedStatus(e.target.value as string)}
                        fullWidth
                        displayEmpty
                        inputProps={{ 'aria-label': 'Select status' }}
                    >
                        <MenuItem value="" disabled>
                            Select new status
                        </MenuItem>
                        {statusOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </Select>
                </Box>
                <Typography variant="body1">
                    Are you sure you want to change the order status?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCancelStatusChange} color="error">
                    Cancel
                </Button>
                <Button
                    onClick={handleConfirmStatusChange}
                    color="primary"
                    disabled={!selectedStatus}
                >
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    )
}
